<script>
  import { screen } from './';
  import { get } from 'svelte/store';
  import { onMount } from 'svelte';
  import Loading from '@components/loading/index.svelte';

  let Component = null;
  let currentScreen = '';

  async function loadComponent() {
    const newScreen = get(screen);
    if (newScreen === currentScreen) return;
    currentScreen = newScreen;

    if (newScreen === 'mobile') {
      const module = await import('./MobileLayout.svelte');
      Component = module.default;
    } else if (newScreen === 'tablet') {
      //const module = await import("./TabletLayout.svelte");
      const module = await import('./DesktopLayout.svelte');
      Component = module.default;
    } else {
      const module = await import('./DesktopLayout.svelte');
      Component = module.default;
    }
  }

  onMount(async () => {
    await loadComponent();
  });

  $: if ($screen) {
    loadComponent();
  }
</script>

{#if Component}
  <svelte:component this={Component} {...$$restProps} />
{:else}
  <Loading message="Đang tải..." />
{/if}
